import { CLASSIFICATION_COLORS } from '@sonar-software/sonar-ts-constants';
import { ClassificationLevel } from '@sonar-software/sonar-core';
import React from 'react';
import { Space } from 'antd';
import { When } from 'react-if';

function getLabelEntry(level: ClassificationLevel) {
	return (
		<div className='grouping'>
			<span
				className='group-dot'
				style={ {
					backgroundColor: `${CLASSIFICATION_COLORS[ level.toLowerCase() ]}19`,
					borderColor: CLASSIFICATION_COLORS[ level.toLowerCase() ]
				} } />
			<span className='group-label'>{ level }</span>
		</div>
	);
}

export interface ClassificationLegendProps {
	groupIds: Array<string>;
};

export const ClassificationLegend: React.FC<ClassificationLegendProps> = ({ groupIds }) => {
	const groups = groupIds.map((entry) => entry.replace('-combo', ''));

	return (
		<Space
			align='start'
			size='small'
			wrap>
			<When condition={ groups.includes(ClassificationLevel.Critical.toLowerCase()) }>
				{ getLabelEntry(ClassificationLevel.Critical) }
			</When>
			<When condition={ groups.includes(ClassificationLevel.High.toLowerCase()) }>
				{ getLabelEntry(ClassificationLevel.High) }
			</When>
			<When condition={ groups.includes(ClassificationLevel.Medium.toLowerCase()) }>
				{ getLabelEntry(ClassificationLevel.Medium) }
			</When>
			<When condition={ groups.includes(ClassificationLevel.Low.toLowerCase()) }>
				{ getLabelEntry(ClassificationLevel.Low) }
			</When>
		</Space>
	);
};
